import { useContext, useMemo } from 'react';
import { AuthenticationContext } from '../../homeModules/auth/contexts/AuthenticationContext';
import { useCollectionsPermissions } from './useCollectionsPermissions';
import {
  getCollectionsSelectedLocation,
  CollectionsCorporateLocation,
} from '../navigation/components/CollectionsLocationToggle';

/**
 * The active Collections city for the current user.
 *
 * Admins choose freely and their choice lives in sessionStorage. Everyone else is pinned to the
 * city on their account and sessionStorage is ignored entirely — a stale key from before this
 * change would otherwise make every request 403.
 *
 * Returns null for a non-admin whose account has no location; the API denies those requests, and
 * defaulting here would only hide that.
 */
export const useCollectionsLocation = (): CollectionsCorporateLocation | null => {
  const { user } = useContext(AuthenticationContext);
  const { isCollectionsAdmin } = useCollectionsPermissions();

  return useMemo(() => {
    if (isCollectionsAdmin) return getCollectionsSelectedLocation();
    return (user?.collections_location as CollectionsCorporateLocation) ?? null;
  }, [isCollectionsAdmin, user]);
};
